
@let _customData = this.customData();

<div *ngIf="sections.length>0 && _customData != null" class="d-flex flex-column align-items-center form-area" style="width: 100%;">
    <div  class="d-flex justify-content-start header mat-title"  style=" width: 100%; padding-left: 16px; padding-bottom: 16px;">
        Previsualització del formulari
    </div>
    <app-page-scroll-content>
        <div class="d-flex justify-content-center" >
            <div style="width: 1500px;">
                <div class="d-flex flex-column">
    
                    <ng-container *ngFor="let section of sections">
                        <app-form-instance [controller]="getController(section)" [section]="section" [customData]="_customData">

                        </app-form-instance>
    
                    </ng-container>
    
                </div>
    
            </div>
    
        </div>
    </app-page-scroll-content>

    @if (this.data != null) {
        
        <div class="d-flex justify-content-end footer" style="width: 100%; padding-right: 16px; padding-top: 16px;">
            <button mat-flat-button mat-dialog-close color="primary" style="padding: 20px;">Tancar</button>
        </div>

    }
    
</div>